<template>
  <div class="landing-page-container article-content no-copy">
    <div class="">
      <div class="panel panel-default landing-page">
        <div class="landing-page-div">

          <section class="header-container">
            <div class="container">
              <!-- center -->
              <b-row class="article-hero-row d-flex align-items-center justify-content-center"
                :class="isAr ? 'text-right' : 'text-left'">
                <b-col lg="8" md="12" sm="12" xs="12">
                  <div style="margin-top:100px;margin-bottom:50px">
                    <h1>{{ item.title }}</h1>
                    <div class="header-li">
                      <ul>
                        <template v-if="!showMoreTitles && item.sections.length > 5">
                          <li v-for="i in 5" :key="i">
                            {{ item.sections[i - 1]?.title }}
                          </li>
                        </template>
                        <template v-if="showMoreTitles && item.sections.length > 5">
                          <li v-for="i in item.sections" :key="i">
                            {{ i.title }}
                          </li>
                        </template>
                        <b-link v-if="item.sections.length > 5" @click="showMoreTitles = !showMoreTitles">
                          {{ showMoreTitles ? langDec.article_show_less : langDec.article_show_more }}
                        </b-link>

                        <template v-if="item.sections.length <= 5">
                          <li v-for="i in item.sections" :key="i">
                            {{ i.title }}
                          </li>
                        </template>
                      </ul>
                      <br><br>

                      <!-- share btn circle -->
                      <div class="share-btn-circle">
                        <div @click="copyCurrentUrl" :title="langDec.article_copy_link_title" class="share-btn"
                          style="background-color: green;display: inline; padding: 10px 15px;border-radius: 50%;">
                          <i class="fa fa-copy" style="color: white;font-size: 20px;"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col lg="4" md="12" sm="12" xs="12">
                  <div style="margin-top:100px;margin-bottom:50px">
                    <img style="width: 400px;
                      height: 400px; object-fit: cover;" class="gridSection-img"
                      :src="item.imageUrl">
                  </div>
                </b-col>
              </b-row>
            </div>
          </section>

          <section>
            <div class="container">
              <b-row :class="isAr ? 'text-right' : 'text-left'">
                <!-- details -->
                <b-col lg="8" md="12" sm="12" xs="12">
                  <div style="margin-top:50px;margin-bottom:100px">
                    <div class="my-5" v-for="i in item.sections" :key="i.title">
                      <h4 class="mb-4"><b>
                          <span class="article-section-bullet"></span>
                          {{ i.title }}</b></h4>
                      <div class="p-3 rounded shadow-sm" style="
                              background-color: #fff;
                              border: 1px solid #e0e0e0;
                            ">
                        <div v-html="i.conetent"></div>
                      </div>
                    </div>
                  </div>
                </b-col>
                <!-- more -->
                <b-col lg="4" md="12" sm="12" xs="12">
                  <div style="margin-top:50px;margin-bottom:100px">
                    <!-- hide the current id -->

                    <articles :hidecurrentId="currentId" :seeMoreBtn="true" :loadMore="false" :pageSize="4" cols="12">
                    </articles>
                  </div>
                </b-col>
              </b-row>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendRequest } from "../utils/RequestHelper.js"
import articles from "../components/ArticlesSection.vue"
import { mapGetters } from "vuex"

export default {
  name: 'Home',
  data() {
    return {
      item: {},
      pageIsLoading: true,
      currentId: null,
      showMoreTitles: false
    }
  },
  components: {
    articles
  },
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {}
    },
    isAr() {
      return this.getlang === "ar"
    },
  },
  watch: {
    "$route.params.id"(id) {
      if (!id) return
      this.currentId = id
      this.showMoreTitles = false
      this.loadData()
    },
  },
  methods: {
    copyCurrentUrl() {
      const currentUrl = window.location.href;
      navigator.clipboard.writeText(currentUrl)
        .then(() => {
          this.$bvToast.toast(this.langDec.article_copy_success_body, {
            title: this.langDec.article_copy_success_title,
            variant: 'success',
            solid: true,
            noCloseButton: true
          });
        })
        .catch(err => {
          this.$bvToast.toast(this.langDec.article_copy_error_body, {
            title: this.langDec.article_copy_error_title,
            variant: 'danger',
            solid: true,
            noCloseButton: true
          });
          console.error('Clipboard copy failed', err);
        });
    },

    loadData() {
      this.pageIsLoading = true;
      var successCallback = (response) => {
        console.log(response);
        this.pageIsLoading = false;
          const currentUrl = window.location.href;
          console.log(currentUrl);
          response.data.data.imageUrl = process.env.VUE_APP_API_URL_IMAGE + response.data.data.imageUrl

         this.item = response.data.data;
        this.item.sections = [...this.item.sections];
      };
      var errorCallback = (error) => {
        console.error(error);
        this.pageIsLoading = false;
        this.alertType = "danger";
        this.alertText = this.langDec["errorMessage"];
        this.alertCountdown = process.env.VUE_APP_ALERT_COUNTDOWN;
        this.$router.push({ name: "home" });
      };

      sendRequest(
        "get",
        //"Blog?articleId=" + this.currentId,
        "Blog/slug/" + this.currentId,
        true,
        null,
        successCallback,
        errorCallback
      );
    }
  },
  created() {
    this.currentId = this.$route.params.id
    this.loadData();
  }
}
</script>
<style scoped>
.header-container {
  background-color: #f4f4f4;
}

.article-section-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: green;
  margin-inline-end: 8px;
  vertical-align: middle;
}

.header-li {
  margin-top: 30px;
}

.header-li li {
  margin-bottom: 10px;
  font-size: 20px;
}

.header-li li::marker {
  color: green;
  /* Changes the bullet color */
  font-size: 1rem;
  /* Makes the bullet larger */
}
</style>

<style scoped>
.article-content {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>